import { AddserviceproviderComponent } from './../addserviceprovider/addserviceprovider.component';
import { AddConfigComponent } from './../add-config/add-config.component';
import { logbaseService } from './../../services/logbase.service';
import { NgxSpinnerService } from "ngx-spinner";
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-serviceprovider',
  templateUrl: './serviceprovider.component.html',
  styleUrls: ['./serviceprovider.component.scss']
})
export class ServiceproviderComponent implements OnInit {
  
  serviceProviders:any[]=[];
  ELEMENT_DATA: Element[];
  dataSource:any[];
  displayedColumns:any[];

   constructor(private logbaseService:logbaseService, public dialog: MatDialog,
    public snackBar: MatSnackBar, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    console.log(JSON.parse(localStorage.getItem('currentUser')));
    this.getServiceProviders();
  }

  getServiceProviders(){
    this.spinner.show();
  this.logbaseService.getServiceProviders().subscribe(result=>{
    this.displayedColumns = ['serviceProviderEn', 'serviceProviderJp', 'updatedBy', 'updatedDate', 'edit','delete'];
    this.dataSource=result.response;
    this.spinner.hide();
    })
  }

  editServiceProvider(currentRow){
    let dialogRef=this.dialog.open(AddserviceproviderComponent,{
      width:'auto',
      disableClose: true,
      data:{type: 'editServiceProvider', serviceProviderData:currentRow}

    })
    dialogRef.afterClosed().subscribe(result=>{
      if(result!='Close')
        this.getServiceProviders();
    })
  }

  openServiceProvider(){
    let dialogRef=this.dialog.open(AddserviceproviderComponent,{
      width:'auto',
      disableClose: true,
      data:{type: 'addServiceProvider'}

    })
    dialogRef.afterClosed().subscribe(result=>{
     if(result!='Close')
        this.getServiceProviders();
    })

  }

  deleteServiceProvider(currentRow:any){
    let dialogRef=this.dialog.open(AddserviceproviderComponent,{
      width:'auto',
      disableClose: true,
      data:{type: 'deleteServiceProvider',serviceProviderData:currentRow}

    })
    dialogRef.afterClosed().subscribe(result=>{
     if(result!='Close')
        this.getServiceProviders();
    })
  }

  openSnackBar(msg:string) {

    this.snackBar.open(msg,'',{
      duration: 1000
    });
    
  }

}


